import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axiosApi';
import { comOffline, somenteOnline } from '../../../offline/servico';
import { buscarParceiros } from '../../../offline/cadastros';

export interface IListagemParceiros {
   idparceiro: string,
   nome: string,
   cpf: string,
   fantasia:string,
   cfop: number;
   diasvencimento: number;
   status: boolean;
}
export interface IDetalheParceiros {
    nome:string,
    cpf:string,
    fantasia:string,
    rg:string,
    telefone: string,
    celular: string,
    endereco: string,
    numero: string,
    bairro: string,
    idmunicipio:string,
    cep:string,
    email: string,
    obs: string,
    cfop: number,
    contribuinte: number,
    presenca: number,
    consumidorfinal:number,  
    emailnfe: string;
    enviaremail: boolean;
    status: boolean;

}

type TotalCount = {
    data: IListagemParceiros[];
    totalCount: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}


const getAll = async (pagina = 1, filter = '', tipo='', limit = Environment.LIMITE_DE_CADASTRO): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/parceiros?page=${pagina}&limit=${limit}&filter=${filter}&tipo=${tipo}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || limit),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IDetalheParceiros | Error> => {
  try {
    const { data } = await Api.get(`/parceiros/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createOnline = async (dados: IDetalheParceiros): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheParceiros>('/parceiros',  {idparceiro: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateByIdOnline = async (id: string, dados: IDetalheParceiros): Promise<void | Error> => {
  try {
    await Api.put(`/parceiros/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteByIdOnline = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/parceiros/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllListOnline = async (filter = '', id = ''): Promise<TotalCount | Error> => {
  try {
    // Só busca por id quando o usuário ainda não digitou nada — ver mesmo fix em
    // MunicipiosService.getAlllist.
    const urlRelativa: string = (filter === '' && id !== '') ? `/parceiroslist/${id}` : `/parceiroslist?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}&tipo=nome`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// ---------- Offline (ver shared/offline) ----------
const getAllList = (filter = '', id = ''): Promise<TotalCount | Error> =>
  comOffline(
    () => getAllListOnline(filter, id),
    () => buscarParceiros(filter, filter === '' ? id : '', 1, Environment.LIMITE_DE_LINHAS),
  );
const create = (dados: IDetalheParceiros) => somenteOnline(() => createOnline(dados));
const updateById = (id: string, dados: IDetalheParceiros) => somenteOnline(() => updateByIdOnline(id, dados));
const deleteById = (id: string) => somenteOnline(() => deleteByIdOnline(id));

export const ParceirosService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAllList,
};